import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "blog-posts" }
const _hoisted_4 = {
  key: 1,
  class: "page-navigation"
}
const _hoisted_5 = { class: "flex-auto text-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitleComponent = _resolveComponent("PageTitleComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_UserMessageComponent = _resolveComponent("UserMessageComponent")!
  const _component_AddIcon = _resolveComponent("AddIcon")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageActionsBarComponent = _resolveComponent("PageActionsBarComponent")!
  const _component_BlogPostComponent = _resolveComponent("BlogPostComponent")!
  const _component_ArrowLeftIconComponent = _resolveComponent("ArrowLeftIconComponent")!
  const _component_ArrowRightIconComponent = _resolveComponent("ArrowRightIconComponent")!
  const _component_PageContentComponent = _resolveComponent("PageContentComponent")!

  return (_openBlock(), _createBlock(_component_PageContentComponent, { class: "blog-view" }, {
    default: _withCtx(() => [
      _createVNode(_component_PageTitleComponent, { title: "Blog" }),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingComponent, { message: "Loading Blog Posts" })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_UserMessageComponent, { details: _ctx.userMessage }, null, 8, ["details"]),
      (!_ctx.isLoading && !_ctx.userMessage.isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_PageActionsBarComponent, { key: 0 }, {
                  right: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/blog/post/edit" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ButtonComponent, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_AddIcon)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogPosts, (blogPost) => {
                return (_openBlock(), _createBlock(_component_BlogPostComponent, {
                  key: blogPost,
                  blogPost: blogPost
                }, null, 8, ["blogPost"]))
              }), 128))
            ]),
            (_ctx.maxPages > 1)
              ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                  _createVNode(_component_PageActionsBarComponent, null, {
                    center: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex-1 text-center", { 'is-disabled': _ctx.currentPage === 1 }])
                      }, [
                        _createVNode(_component_router_link, { to: _ctx.routerPrevPage }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowLeftIconComponent)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ], 2),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.currentPage), 1),
                        _hoisted_6,
                        _createElementVNode("small", null, "/ " + _toDisplayString(_ctx.maxPages), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex-1 text-center", { 'is-disabled': _ctx.currentPage === _ctx.maxPages }])
                      }, [
                        _createVNode(_component_router_link, { to: _ctx.routerNextPage }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowRightIconComponent)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ], 2)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}